import { render, staticRenderFns } from "./PreviousPageArrow.vue?vue&type=template&id=38a1edf9&"
import script from "./PreviousPageArrow.vue?vue&type=script&lang=ts&"
export * from "./PreviousPageArrow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports